import { Controller } from "@hotwired/stimulus";

// Envia um formulário a partir de um botão que fica fora dele, usando um dos botões do próprio
// formulário como submitter (o name/value dele vai junto). Existe para não usar o atributo `form`
// num botão de submit fora do form: o primeiro submit associado ao form, na ordem do documento, é
// o que o Enter num campo de texto aciona, e um botão acima do form tomaria esse lugar.
export default class extends Controller {
  static values = { form: String, submitter: String };

  submit(event) {
    event.preventDefault();
    const form = document.getElementById(this.formValue);
    if (!form) return;

    const submitter = this.submitterValue ? form.querySelector(this.submitterValue) : null;
    form.requestSubmit(submitter || undefined);
  }
}
